import { render } from "./edit-table.vue?vue&type=template&id=32cd6ffc&scoped=true&ts=true"
import script from "./edit-table.vue?vue&type=script&lang=ts"
export * from "./edit-table.vue?vue&type=script&lang=ts"

import "./edit-table.vue?vue&type=style&index=0&id=32cd6ffc&lang=scss&scoped=true"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cd6ffc"]])

export default __exports__